import React from "react";
import App from "./App";
import "typeface-metrophobic";
import "typeface-roboto";
import "typeface-exo";
import "typeface-lato";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";

const root = createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
